import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";

/**
 * Fixed overlay z teksturą filmowego ziarna na całej stronie.
 * Czysty SVG (feTurbulence) - zero requestów sieciowych, zero dodatkowych plików.
 * pointer-events: none, więc nie przeszkadza w klikaniu niczego pod spodem.
 *
 * Wstaw raz, na najwyższym poziomie layoutu (np. w App.tsx, obok <LenisProvider>).
 * Przy prefers-reduced-motion nadal się renderuje (to statyczna tekstura, nie animacja),
 * ale można ją łatwo wyłączyć przekazując `disabled`.
 */
export function GrainOverlay({ opacity = 0.035, disabled = false }: { opacity?: number; disabled?: boolean }) {
  const reducedMotion = usePrefersReducedMotion();
  if (disabled) return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        pointerEvents: "none",
        opacity: reducedMotion ? opacity * 0.6 : opacity,
        mixBlendMode: "overlay",
      }}
    >
      <svg width="100%" height="100%" style={{ width: "100%", height: "100%" }}>
        <filter id="premium-grain-filter">
          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" stitchTiles="stitch" result="noise" />
          <feColorMatrix in="noise" type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.9 0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#premium-grain-filter)" />
      </svg>
    </div>
  );
}
